import React, { ReactNode } from "react"

import { FormHelperText, SxProps, Theme } from "@mui/material"

import {
  StyledFormControl,
  StyledInputLabel,
  StyledMenuItem,
  StyledSelect,
  StyledSelectProps
} from "./styled"

export type SelectorOption<T = any> = {
  disabled?: boolean,
  title: string,
  value: any,
  item?: T
}

export type SelectorProps = StyledSelectProps & {
  formControlSX?: SxProps<Theme>,
  fullWidth?: boolean,
  helperText?: string,
  isInvalid?: boolean,
  showPlaceholderOption?: boolean,
  showPlaceholderOptionTitle?: boolean,
  options: SelectorOption[],
  renderOptionContent?: (option: SelectorOption) => ReactNode,
  noBorders?: boolean
  hideInput?: boolean
  height?: number

}

export const Selector = ({
                           formControlSX = {
                             height: "auto",
                             m: 0,
                             minWidth: 200
                           },
                           fullWidth = true,
                           helperText = "",
                           isInvalid = false,
                           label,
                           options = [],
                           placeholder,
                           showPlaceholderOptionTitle = true,
                           showPlaceholderOption = true,
                           variant = "filled",
                           renderOptionContent,
                           noBorders = false,
                           hideInput = false,
                           height,
                           ...props
                         }: SelectorProps) => (
  <StyledFormControl
    fullWidth={fullWidth}
    className={"CirrusSelector"}
    variant={variant}
    sx={{ m: 0, ...formControlSX }}
  >
    {label && <StyledInputLabel margin="dense">{label}</StyledInputLabel>}

    <StyledSelect
      displayEmpty={!!placeholder}
      label={label}
      noBorders={noBorders}
      height={height}
      inputProps={{
        id: `${props.id || SELECTOR_ID}-input`,
        ...hideInput && { style: { display: "none" } }
      }}
      renderValue={(selected) => {
        if (!selected) return <span className="selector-placeholder">{placeholder}</span>

        const title = options.find(({ value }) => value === selected)?.title

        return <span>{title}</span>
      }}
      {...props}
    >
      {
        placeholder
        && showPlaceholderOption
        &&
        <StyledMenuItem className="selector-placeholder" value={""}>
          {showPlaceholderOptionTitle
            ? placeholder
            : ""}
        </StyledMenuItem>
      }

      {options.map((option) => (
        <StyledMenuItem key={option.value} value={option.value} sx={{ height: "44px" }} disabled={option.disabled}>
          {renderOptionContent?.(option) ?? option.title}
        </StyledMenuItem>
      ))}
    </StyledSelect>
    {
      helperText
      && <FormHelperText error={isInvalid}>{helperText}</FormHelperText>
    }
  </StyledFormControl>
)

const SELECTOR_ID = "selector-id"
